import { ACTIVITY_EFFECTIVENESS_SEGMENTS } from '../activityEffectivenessSegments'
import dayjs from '../../../../utils/dayjsConfig'
import { formatMoney, getLocale } from '../../../../helpers/utils'
import { buildActivityEffectivenessValues } from '../routeKpiValues'
import { buildActivityTableRows } from '../activityBreakdownFilters'
import { buildUserReportPdf } from './routeExecutionPdfBuilder'

export const buildActivityExportSummary = (overview, segment = 'general') => {
  const selected =
    ACTIVITY_EFFECTIVENESS_SEGMENTS[segment] || ACTIVITY_EFFECTIVENESS_SEGMENTS.general
  const values = buildActivityEffectivenessValues(overview, segment)
  return {
    kpis: [
      {
        title: `${selected.title} · ${selected.label}`,
        value: `${values.effectiveness}%`,
        subtitle: selected.formula,
        metrics: [
          ['Clientes en ruta (Meta)', values.planned],
          ['Atendidos en ruta', values.attendedInRoute],
          ['Clientes sin atender', values.unattended],
          ['Atendidos fuera de ruta', values.outside]
        ],
        footer: `Total atendidos: ${values.totalAttended}`
      },
      {
        title: 'Actividades dentro de geocerca',
        value: overview
          ? `${overview.geofence_effective_clients_count}/${overview.geofence_location_available_count}`
          : '0/0',
        subtitle: 'Actividades realizadas dentro de geocerca',
        metrics: [],
        footer: 'Fijo, no varía por tipo de actividad'
      }
    ],
    totals: [
      ['order', 'Total Pedidos', 'pedidos'],
      ['refund', 'Total Devoluciones', 'devoluciones'],
      ['charge', 'Total Cobros', 'cobros'],
      ['delivery', 'Total Entregas', 'entregas']
    ]
      .filter(([key]) => Number(overview?.[`total_${key}_count`] ?? 0) > 0)
      .map(([key, title, label]) => ({
        title,
        value: formatMoney(Number(overview?.[`total_${key}`])),
        footer: `${new Intl.NumberFormat(getLocale()).format(Number(overview?.[`total_${key}_count`]) || 0)} ${label}`
      }))
  }
}

export const activityLocationUrl = (row) => {
  const raw = row.rawRow || {}
  if (
    row.isLiquidation ||
    raw.latitude == null ||
    raw.longitude == null ||
    raw.latitude === '' ||
    raw.longitude === ''
  )
    return ''
  const lat = Number(raw.latitude)
  const lng = Number(raw.longitude)
  return Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180
    ? `https://www.google.com/maps?q=${lat},${lng}`
    : ''
}

export const buildActivityBreakdownPdf = ({
  results = [],
  overview,
  effectivenessSegment,
  formatActivityName = (name) => name,
  startDate,
  endDate,
  ...header
}) => {
  const rows = buildActivityTableRows(results, formatActivityName)
  const summary = buildActivityExportSummary(overview, effectivenessSegment)
  const doc = buildUserReportPdf({
    ...header,
    ...summary,
    period: `${dayjs(startDate).format('DD/MM/YYYY')} - ${dayjs(endDate).format('DD/MM/YYYY')}`,
    generatedAt: dayjs().format('DD/MM/YYYY hh:mm A'),
    title: 'Desglose de actividades',
    tableTitle: 'ACTIVIDADES · RESUMEN',
    headers: [
      'Fecha y hora',
      'Cliente',
      'Actividad',
      'Motivo/Descripción',
      'Monto',
      'Dentro de geocerca',
      'Ubicación'
    ],
    rows: rows.map((row) => [
      row.createdDateLabel,
      row.clientLabel,
      row.activityLabel,
      row.motiveText,
      row.totalLabel,
      row.geofenceLabel,
      activityLocationUrl(row) ? 'Ver mapa' : '-'
    ]),
    columnStyles: {
      0: { cellWidth: 85 },
      1: { cellWidth: 140 },
      2: { cellWidth: 108 },
      3: { cellWidth: 197 },
      4: { cellWidth: 76, halign: 'right' },
      5: { cellWidth: 75 },
      6: { cellWidth: 55, halign: 'center' }
    },
    chipColumns: [2, 5],
    onDrawCell: ({ cell, row, column, section }, pdf) => {
      if (section !== 'body' || column.index !== 6) return
      const url = activityLocationUrl(rows[row.index] || {})
      if (url) pdf.link(cell.x, cell.y, cell.width, cell.height, { url })
    }
  })
  return doc
}
